import React from 'react'
import InfiniteSelect from '../../../InfiniteSelect'
import ApiService from '../../../../services/ApiService'
import PantoneSelect, { PantoneValue } from '../../../PantoneSelect'
import { InputDiv, Label } from '../../../styles/modal-style'

interface ColorFieldProps {
  isFashionTenant: boolean
  colorError: boolean
  pantoneError: boolean
  originalColorName: string | null
  selectedColor: { id: number; name: string; pantone?: any } | null
  pendingColorPantone: any
  setSelectedColor: (value: { id: number; name: string; pantone?: any } | null) => void
  setPendingColorPantone: (value: any) => void
  setColorError: (v: boolean) => void
  setPantoneError: (v: boolean) => void
}

const ColorField: React.FC<ColorFieldProps> = ({
  isFashionTenant,
  colorError,
  pantoneError,
  originalColorName,
  selectedColor,
  pendingColorPantone,
  setSelectedColor,
  setPendingColorPantone,
  setColorError,
  setPantoneError,
}) => {
  if (!isFashionTenant) return null

  return (
    <>
      <InputDiv>
        <Label style={colorError ? { color: 'red' } : {}}>
          Cor
          <span style={{ color: 'red', marginLeft: 2 }}>*</span>
          {colorError && (
            <span style={{ fontSize: '12px', color: 'red', marginLeft: 6, fontWeight: 400 }}>
              A cor é obrigatória!
            </span>
          )}
          {!colorError && originalColorName && (
            <span style={{ fontSize: '12px', color: '#6B7280', marginLeft: 6, fontWeight: 400 }}>
              (original: <strong>{originalColorName}</strong>)
            </span>
          )}
        </Label>
        <div style={colorError ? { border: '1px solid red', borderRadius: 6, overflow: 'hidden' } : {}}>
          <InfiniteSelect
            mode="crud"
            value={selectedColor}
            onSelect={(option) => {
              setSelectedColor(option)
              setColorError(false)
              setPendingColorPantone(option?.pantone ?? null)
            }}
            fetchFunction={async (limit, offset, search?) => {
              const response = await ApiService.resources.getColors()
              const items = response.data || []
              const filtered = search
                ? items.filter((c: any) => c.name?.toLowerCase().includes(search.toLowerCase()))
                : items
              return filtered.map((c: any) => ({ id: c.id, name: c.name, pantone: c.pantone ?? null }))
            }}
            onItemCreate={async (name: string) => {
              if (!pendingColorPantone?.code) {
                throw new Error('Selecione um Pantone antes de criar uma nova cor.')
              }
              const response = await ApiService.resources.createColor({ name, pantone: pendingColorPantone })
              const created = response.data
              setSelectedColor(created)
              setPendingColorPantone(created.pantone ?? pendingColorPantone)
              return created
            }}
            onItemDelete={async (colorId: any) => {
              await ApiService.resources.deleteColor(colorId)
            }}
            placeholder="Buscar ou criar cor"
            allowCreate={true}
            allowDelete={true}
            showCreateOnlyIfNotExists={true}
            minCreateLength={2}
          />
        </div>
      </InputDiv>

      <InputDiv>
        <Label style={pantoneError ? { color: 'red' } : {}}>
          Pantone
          {pantoneError && (
            <span style={{ fontSize: '12px', color: 'red', marginLeft: 6, fontWeight: 400 }}>
              Pantone é obrigatório para a cor
            </span>
          )}
        </Label>
        <PantoneSelect value={pendingColorPantone} onSelect={(value: PantoneValue | null) => { setPendingColorPantone(value); setPantoneError(false) }} />
      </InputDiv>
    </>
  )
}

export default ColorField
